// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)


import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';


Vue.config.productionTip = false

Vue.use(ViewUI);

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer);
// import http from './store/http'

// Vue.prototype.$http = http;

import store from "./store/store"

let project = process.env.PROJECT

Vue.prototype.$api = require('@/api/common.js').default;
Vue.prototype.$dengji = require('@/util/index.js').getUserDengji;
Vue.prototype.$checkSession = require('@/util/index.js').checkSession;
Vue.prototype.$cache = require('@/util/cache.js').getUserDengji;
Vue.prototype.$util = require('@/util/util.js').default;
let w = document.documentElement.clientWidth;
// w = screen.width * window.devicePixelRatio
if (w >= 100) {
  w = w - 100;
}
if (w < 1180) {
  w = 1180;
}
Vue.prototype.$w = w;

Vue.prototype.$Message.config({
  top: 500,
  duration: 3
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js